import * as React from 'react'

export default function InstagramIcon(props) {
  const { color = '#fff' } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} viewBox="0 0 50 50" {...props}>
      <path
        d="M16 46h18c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12H16C9.373 4 4 9.373 4 16v18c0 6.627 5.373 12 12 12z"
        style={{
          fill: 'none',
          stroke: color,
          strokeWidth: 2,
          strokeMiterlimit: 10,
        }}
      />
      <circle
        cx={25}
        cy={25}
        r={10}
        style={{
          fill: 'none',
          stroke: color,
          strokeWidth: 2,
          strokeMiterlimit: 10,
        }}
      />
      <circle
        style={{
          fill: color,
        }}
        cx={37}
        cy={13}
        r={2}
      />
    </svg>
  )
}
